import React from 'react';

const ImageTagIcon = () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><path d="M21 15l-5-5L5 21" />
    </svg>
);

const MoonIcon = () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
);

const SunIcon = () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </svg>
);

const SceneCard = ({ scene, onEdit, onDelete, label = 'Scene', hideEdit = false }: any) => (
    <div className="cs-scene-card">
        <div className="cs-scene-card__top">
            <span className="cs-scene-card__name">{scene?.set_name}</span>
            <div className="cs-scene-card__actions">
                {!hideEdit &&
                    <button type="button" className="cs-icon-btn cs-icon-btn--edit" onClick={onEdit} aria-label="Edit scene">
                        <img src="/assets/images/edit-pencil-icon.svg" alt="edit" />
                    </button>
                }
                <button type="button" className="cs-icon-btn cs-icon-btn--delete" onClick={onDelete} aria-label="Delete scene">
                    <img src="/assets/images/trash-red-icon.svg" alt="delete" />
                </button>
            </div>
        </div>
        <div className="cs-scene-card__tags">
            <span className="cs-tag">
                <ImageTagIcon /> {label} {scene?.scene_number}
            </span>
            <span className="cs-tag">
                {scene?.day_or_night === 'night' ? <MoonIcon /> : <SunIcon />}
                {scene?.day_or_night === 'night' ? 'Night' : 'Day'}
            </span>
        </div>
    </div>
);

export default SceneCard;